const EducationAndTrainingEntity = {
    "year" :{
        "_text" : ""
    },
    "title" : {
        "_text" : ""
    },
    "location" : {
        "_text" : ""
    }
}

export default EducationAndTrainingEntity;